export default function () {
  if (
    Array.from(
      document.querySelectorAll(
        '.PostsGridContainer:not(.ExpertsPicks .PostsGridContainer, .CategoryPageFeaturedPosts .PostsGridContainer)'
      )
    ).length > 0 ||
    Array.from(
      document.querySelectorAll(
        '.ExpertsPicks, .AdventureGuide, .PageMain--adventure-guide .AdventureGuidePostsGrid'
      )
    ).length > 0
  ) {
    import(/* webpackChunkName: "show-posts-module" */ './show-posts').then(
      (module) => {
        const ShowPosts = module.default
        ShowPosts()
      }
    )
  }
}
